const Symbols = {
    AnchorContext: Symbol('AnchorContext'),
    CheckboxContext: Symbol('CheckboxContext'),
    ConfigContext: Symbol('ConfigContext'),
    FormContext: Symbol('FormContext'),
    LayoutContext: Symbol('LayoutContext'),
    LayoutSiderContext: Symbol('LayoutSiderContext'),
    ListContext: Symbol('ListContext'),
    LocaleContext: Symbol('LocaleContext'),
    MenuContext: Symbol('MenuContext'),
    ModalContext: Symbol('ModalContext'),
    RadioContext: Symbol('RadioContext'),
    TableContext: Symbol('TableContext'),
    TableRowContext: Symbol('TableRowContext'),
    TableInnerRowContext: Symbol('TableInnerRowContext'),
    TabsContext: Symbol('TabsContext'),
    TreeContext: Symbol('TreeContext'),
    ProFormContext: Symbol('ProFormContext'),
    ProTableContext: Symbol('ProTableContext'),
    ProPerformanceTableContext: Symbol('ProPerformanceTableContext'),
    MentionsContext: Symbol('MentionsContext'),
    AvatarContext: Symbol('AvatarContext'),
    BoardContext: Symbol('BoardContext'),
};
export default Symbols;
